"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uaParserJs = _interopRequireDefault(require("ua-parser-js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line max-len
var svgFilter = '<svg style="position:absolute;height:0px"><filter id="EDGElDCZudYwNm" filterUnits="objectBoundingBox" x="-100%" y="-100%" width="400%" height="400%"><feGaussianBlur in="SourceAlpha" result="drop_shadow_1" stdDeviation="3"></feGaussianBlur><feOffset dx="2.121320343559643" dy="2.1213203435596424" in="drop_shadow_1" result="drop_shadow_2"></feOffset><feFlood flood-color="#000000" flood-opacity="0.18" result="drop_shadow_3"></feFlood><feComposite in="drop_shadow_3" in2="drop_shadow_2" operator="in" result="drop_shadow_4"></feComposite><feMerge><feMergeNode></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></svg>';

var Init = function Init() {
  var parser = new _uaParserJs.default();

  if (parser.getBrowser().name === 'Edge') {
    // need to inject svg filter to dom
    var div = document.createElement('div');
    div.innerHTML = svgFilter;
    document.body.appendChild(div);
  }
};

var _default = Init;
exports.default = _default;